import React from 'react'

const Hamburger = ({ size = '24px', color = "#323232"}) => (
<svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3 5.25V6.75H21V5.25H3ZM3 11.25V12.75H21V11.25H3ZM3 17.25V18.75H21V17.25H3Z" fill={color}/>
</svg>

  );

  export default Hamburger